import React from 'react';
import { motion } from 'framer-motion';
import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { TypeAnimation } from 'react-type-animation';
import { FaGithub, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import heroImage from '../images/hero.jpg';
import './Hero.css';
  const Hero = () => {
    const particlesInit = useCallback(async (engine) => {
      await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
      // Add this callback
    }, []);

    const particlesConfig = {
      fullScreen: { enable: false },
      particles: {
        number: { value: 40 },
        color: { value: "#64ffda" },
        shape: {
          type: "star"
        },
        opacity: {
          value: 0.6,
          random: true
        },
        size: {
          value: 4,
          random: true
        },
        move: {
          enable: true,
          speed: 1.5,
          direction: "none",
          random: true,
          straight: false,
          outModes: "out"
        },
        rotate: {
          value: 45,
          random: true,
          direction: "clockwise",
          animation: {
            enable: true,
            speed: 5
          }
        }
      },
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "repulse"
          }
        },
        modes: {
          repulse: {
            distance: 100,
            duration: 0.4
          }
        }
      }
    };
  
  
  
    return (
      <div className="hero-section" style={{backgroundImage: `url(${heroImage})`}}>
        <Particles
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={particlesConfig}
          className="particles-bg"
        />      
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <span className="greeting">Hello, I'm</span>
            <span className="name">Judith Oyugi</span>
            <TypeAnimation
              sequence={[
                'Full Stack Developer',
                2000,
                'Frontend Developer',
                2000,
                'Backend Developer',
                2000,
                'Mobile Developer',
                2000,
                'WordPress Developer',
                2000
              ]}
              wrapper="span"
              className="title"
              repeat={Infinity}
            />
          </motion.h1>

          <motion.p 
            className="hero-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            I build exceptional digital experiences that make an impact
          </motion.p>
            <motion.div 
              className="hero-cta"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <motion.button 
                className="primary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}
              >
                View My Work
              </motion.button>
              <motion.button 
                className="secondary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Contact Me
              </motion.button>
            </motion.div>
          </motion.div>

        <motion.div 
          className="hero-social"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.8 }}
        >
          <a href="https://github.com/JudithOyugi" target="_blank" rel="noopener noreferrer">
            <span className="social-icon-wrapper">
              <FaGithub className="social-icon" />
              <span className="social-name">GitHub</span>
            </span>
          </a>
          <a href="https://ke.linkedin.com/in/judithoyugi-dev" target="_blank" rel="noopener noreferrer">
            <span className="social-icon-wrapper">
              <FaLinkedinIn className="social-icon" />
              <span className="social-name">LinkedIn</span>
            </span>
          </a>
          <a href="https://twitter.com/OyugiJudy" target="_blank" rel="noopener noreferrer">
            <span className="social-icon-wrapper">
              <FaXTwitter className="social-icon" />
              <span className="social-name">Twitter</span>
            </span>
          </a>
        </motion.div>
      </div>
    );
  };
  export default Hero;